/* global angular */

(function() {
    "use strict";

    var app = angular.module('app');

    app.directive('modalView', ['$parse', '$templateRequest', '$compile', '$controller', 'Utils', function ($parse, $templateRequest, $compile, $controller, Utils) {
        var defaultModal = '<div class="modal-header">' +
                            '    <button type="button" class="close" data-dismiss="modal" aria-label="Chiudi" ng-click="modal.reject()">' +
                            '        <span aria-hidden="true">&times;</span>' +
                            '    </button>' +
                            '    <h4 class="modal-title" ng-bind="modal.title"></h4>' +
                            '</div>' +
                            '<div class="modal-body">' +
                            '</div>' +
                            '<div class="modal-footer">' +
                            '    <button type="button" class="btn btn-secondary" data-dismiss="modal" ng-click="modal.reject()">Chiudi</button>';
        '</div>';

        function compileController(scope, element, html, data) {
            // console.log('modalView.compileController', element);
            element.html(html);
            var link = $compile(element.contents());
            if (data.controller) {
                var $scope = scope.$new();
                angular.extend($scope, data);
                var controller = $controller(data.controller, { $scope: $scope });
                if (data.controllerAs) {
                    scope[data.controllerAs] = controller;
                }
                element.data('$ngControllerController', controller);
                element.children().data('$ngControllerController', controller);
                scope = $scope;
            }
            link(scope);
        }

        return {
            restrict: 'A',
            priority: -400,
            link: function (scope, element, attributes, model) {
                var modal = $parse(attributes.modalView);
                modal = modal(scope);
                if (modal.templateUrl) {
                    $templateRequest(modal.templateUrl).then(function (html) {
                        compileController(scope, element, html, modal);
                    });
                } else {
                    compileController(scope, element, defaultModal, modal);
                }
                /*
                // window.scrollTo(0, element[0].offsetTop - 100);
                function onClick(e) {
                    var closest = Utils.getClosestElement(e.target, element[0]);
                    if (closest === null) {
                        modal.reject(null);
                    }
                    // console.log('onClick', closest);
                }
                function addListeners() {
                    angular.element(window).on('click', onClick);
                }
                function removeListeners() {
                    angular.element(window).off('click', onClick);
                }
                scope.$on('destroy', function () {
                    removeListeners();
                });
                setTimeout(function () {
                    addListeners();
                }, 500);
                */
            }
        };
    }]);
    
}());